<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <users-table 
        :tableTitle="tableTitle"  
        :usersArray="getUsers" />
    </div>
  </div>
</template>
<script>
import UsersTable from "@/components/UsersTable.vue"
import { mapStores } from 'pinia'
import { useGeneralStore } from '@/stores/index.js'
const axios = require('axios').default

export default {
  components: {
    UsersTable,
  },
  data() {
    return {
      tableTitle: 'Users',
      generalStore: useGeneralStore(),
    }
  },

  computed: {
    ...mapStores(useGeneralStore)
  },

   async mounted() {
    if (this.getUsers.length === 0) {
      this.generalStore.loading(true)
      try {
        const { data : response } = await axios.post(`https://qws-cms-api.onrender.com/admin/users`, {
          system: this.$store.getters.getSystem
        }, { withCredentials: true })
        
        if (response.doc){
          this.generalStore.loadUsers(response.doc)
          this.generalStore.loading(false)
        }
      } catch (error) {
        console.log(error.response.data.message)
      }  
    }
  }
}
</script>
